import React from 'react';
import Text from '../Text';
import ButtonIcon from '../ButtonIcon';
import cx from 'classnames';
import Tooltip from '../Tooltip';

export default function ChipInput({
  chips,
  placeholder,
  innerRef,
  onChangeInput,
  clearOnValue,
  onRemoveChip,
  onClear,
}) {
  const [inputValue, setInputValue] = React.useState('');

  const onKeyDown = (e) => {
    if (e.key === 'Backspace' && inputValue === '') {
      onRemoveChip(chips.length - 1);
    }
    if (e.key === 'Enter' && inputValue.trim() !== '') {
      e.preventDefault();
      onChangeInput(inputValue + clearOnValue);
      setInputValue('');
    }
  };

  const handleChange = (e) => {
    if (clearOnValue && e.target.value.endsWith(clearOnValue)) {
      setInputValue('');
    } else {
      setInputValue(e.target.value);
    }
    onChangeInput(e.target.value);
  };

  return (
    <div className="chip-input">
      <div className="chip-input__inner">
        <div className="chip-input__left">
          {chips.map((chip, index) => (
            <Tooltip key={index} tooltip={chip.tooltip}>
              <div
                className={cx('chip-input__chip', {
                  [`chip-input__chip--color-${chip.color}`]: chip.color,
                })}
              >
                <Text>{chip.label}</Text>
                <ButtonIcon
                  className="chip-input__remove"
                  icon="cross"
                  iconColor={chip.color === 'yellow' ? 'yellow' : 'white'}
                  onClick={() => onRemoveChip(index)}
                  size="sm"
                ></ButtonIcon>
              </div>
            </Tooltip>
          ))}
          <input
            autoFocus
            className="chip-input__input"
            onChange={handleChange}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            ref={innerRef}
            type="text"
            value={inputValue}
          />
        </div>
        <div className="chip-input__right">
          <ButtonIcon
            className="chip-input__clear"
            icon="cross"
            onClick={onClear}
          ></ButtonIcon>
        </div>
      </div>
    </div>
  );
}
